<template>
  <filter-parent
    v-if="showFilter"
    :aria-label-id="'competence-area-filter'"
    :icon="'filter'"
    :start-open="true"
    :title="texts.needHelpWith"
  >
    <multiselect
      v-if="!isLoadingCompetenceAreas"
      v-model="competenceTypes"
      :aria-labelledby="'competence-area-filter'"
      :group-label="isTherapy ? '' : 'label'"
      :group-values="isTherapy ? '' : 'items'"
      :options="competenceAreaOptions"
      :placeholder="texts.startTyping"
    />
    <multiselect-filter-loader v-else />
  </filter-parent>
</template>

<script>
import Multiselect from 'Components/MultiSelect.vue';
import { hasTherapyRole } from 'Main/contact-form/constants';
import { mapState } from 'vuex';
import FilterParent from '../common/FilterParent.vue';
import MultiselectFilterLoader from './MultiselectFilterLoader.vue';

export default {

  components: {
    FilterParent,
    Multiselect,
    MultiselectFilterLoader,
  },

  computed: {
    ...mapState('counselorGrid', [
      'competenceAreaOptions',
      'presetCompetence',
      'isLoadingCompetenceAreas',
    ]),

    competenceTypes: {
      get() {
        return this.$store.state.counselorGrid.filteredCompetenceAreas;
      },
      set(value) {
        this.$store.commit('counselorGrid/setFilteredCompetenceAreas', value);
      },
    },

    isTherapy() {
      return hasTherapyRole(this.role);
    }, 

    showFilter() {
      return (
        (!this.presetCompetence || this.isTherapy) &&
        (this.isLoadingCompetenceAreas || this.competenceAreaOptions.length > 0)
      );
    }
  },

  data() {
    return {
      texts: theme_vars.counselorGridTexts,
    };
  },
  name: 'CompetenceTypeFilter',

  props: {
    role: {
      required: true,
      type: String,
    },
  },
};
</script>
